import FormattedMessage from 'I18n/components/FormattedMessage';
import SensitivePropertyNamesList from 'automation-ui-management/components/flp/SensitivePropertyNamesList';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FlpRestrictedPropertiesMessage = ({
  label,
  flpRejectionReasons
}) => {
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginInlineEnd: "200",
      as: "div",
      children: flpRejectionReasons.length > 0 ? label : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-management.flp.accessDenied"
      })
    }), /*#__PURE__*/_jsx(SensitivePropertyNamesList, {
      flpRejectionReasons: flpRejectionReasons
    })]
  });
};
export default FlpRestrictedPropertiesMessage;